import { Check } from 'lucide-react';

const plans = [
  {
    name: 'Starter',
    price: 'Free',
    priceLabel: null,
    description: null,
    features: [
      'Up to 5 loads/month',
      '1 driver',
      'Basic dashboard',
      'Email support',
    ],
    cta: 'Get Started',
    ctaStyle: 'outline',
    highlighted: false,
    badge: null,
  },
  {
    name: 'Professional',
    price: '$49',
    priceLabel: '/mo',
    description: null,
    features: [
      'Unlimited loads',
      'Up to 25 drivers',
      'Document vault',
      'Live dashboard',
      'Priority support',
    ],
    cta: 'Start Free Trial',
    ctaStyle: 'gradient',
    highlighted: true,
    badge: 'Most Popular',
  },
  {
    name: 'Enterprise',
    price: 'Custom',
    priceLabel: null,
    description: null,
    features: [
      'Unlimited everything',
      'Custom integrations',
      'Dedicated account manager',
      'SLA guarantee',
      'API access',
    ],
    cta: 'Contact Sales',
    ctaStyle: 'outline',
    highlighted: false,
    badge: null,
  },
];

export default function Pricing() {
  return (
    <section id="pricing" className="bg-white py-24">
      <div className="max-w-6xl mx-auto px-6">
        {/* Eyebrow */}
        <p className="text-center text-blue-600 text-sm font-semibold uppercase tracking-widest mb-3">
          PRICING
        </p>

        {/* Heading */}
        <h2 className="text-center text-4xl font-bold text-gray-900 mb-4">
          Simple Plans. No Surprises.
        </h2>

        {/* Subtext */}
        <p className="text-center text-gray-500 text-lg mb-16">
          Start free, scale as you grow.
        </p>

        {/* Plans Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto items-start">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={
                plan.highlighted
                  ? 'border-2 border-blue-500 rounded-2xl p-8 shadow-xl shadow-blue-500/10 relative'
                  : 'bg-white border border-gray-200 rounded-2xl p-8'
              }
            >
              {/* Badge */}
              {plan.badge && (
                <span className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-blue-600 to-cyan-500 text-white text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-full whitespace-nowrap">
                  {plan.badge}
                </span>
              )}

              {/* Plan Name */}
              <p className="text-lg font-semibold text-gray-900 mb-4">
                {plan.name}
              </p>

              {/* Price */}
              <div className="flex items-end gap-1 mb-8">
                <span className="text-5xl font-bold text-gray-900 font-mono">
                  {plan.price}
                </span>
                {plan.priceLabel && (
                  <span className="text-lg text-gray-400 mb-1">
                    {plan.priceLabel}
                  </span>
                )}
              </div>

              {/* Features */}
              <ul className="space-y-3 mb-8">
                {plan.features.map((feature) => (
                  <li key={feature} className="flex items-center gap-3">
                    <Check className="w-4 h-4 text-green-500 flex-shrink-0" />
                    <span className="text-sm text-gray-600">{feature}</span>
                  </li>
                ))}
              </ul>

              {/* CTA */}
              {plan.ctaStyle === 'gradient' ? (
                <button className="w-full py-3 rounded-xl bg-gradient-to-r from-blue-600 to-cyan-500 text-white font-semibold text-sm hover:opacity-90 transition-opacity">
                  {plan.cta}
                </button>
              ) : (
                <button className="w-full py-3 rounded-xl border border-gray-300 text-gray-700 font-semibold text-sm hover:bg-gray-50 transition-colors">
                  {plan.cta}
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
